import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { isEmpty } from 'ramda';

import ImageSkeleton from '../../components/Skeletons/ImageSkeleton';
import { Label } from '../../components';

const Image = ({ attr, title, src }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const imageClassName = cn('image', { '-hidden': !isImageLoaded });

  const handleImageLoaded = () => {
    setIsImageLoaded(true);
  };

  return (
    <div className="input brand-image-upload">
      <div className="image-upload-header">
        <Label attr={attr} text={title} />
      </div>
      {!(isEmpty(src) || isImageLoaded) && <ImageSkeleton />}
      <img src={src} className={imageClassName} onLoad={handleImageLoaded} />
    </div>
  );
};

export default Image;

Image.propTypes = {
  attr: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
};
